
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[locale]/products/[product_slug]",
      function () {
        return require("private-next-pages/[region]/[locale]/products/[product_slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[locale]/products/[product_slug]"])
      });
    }
  